import { render, staticRenderFns } from "./IssueSample.vue?vue&type=template&id=644697ba&"
import script from "./IssueSample.vue?vue&type=script&lang=ts&"
export * from "./IssueSample.vue?vue&type=script&lang=ts&"
import style0 from "./IssueSample.vue?vue&type=style&index=0&id=644697ba&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports